import { Toast } from "./toast.extentions";

export const formatText = (text: string, length: number) => {
  return `${text.substring(0, length)}${text.length > length ? "..." : ""}`;
};

export const handleCopyText = (text: string | undefined) => {
  if (text) {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          Toast("success", "با موفقیت کپی شد.");
        })
        .catch(() => {
          Toast("error", "متاسفانه امکان کپی وجود ندارد.");
        });
    } else {
      Toast("error", "متاسفانه امکان کپی وجود ندارد.");
    }
  }
};
